import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge class names, letting the caller's classes win.
 *
 * `clsx` handles the conditionals; `twMerge` resolves the conflicts, so a
 * component's default `px-4` is actually replaced by a caller's `px-2` instead
 * of both landing in the class list and the winner being decided by stylesheet
 * order.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
